import { render, staticRenderFns } from "./nombrepromocion.vue?vue&type=template&id=7bcd44ae&scoped=true&"
import script from "./nombrepromocion.vue?vue&type=script&lang=js&"
export * from "./nombrepromocion.vue?vue&type=script&lang=js&"
import style0 from "./nombrepromocion.vue?vue&type=style&index=0&id=7bcd44ae&scoped=true&lang=css&"
import style1 from "./nombrepromocion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcd44ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VAvatar,VCol,VDivider,VIcon,VImg,VParallax,VRow,VStepper,VStepperContent,VStepperItems,VStepperStep})
